// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import {
  ChannelAsset,
  deserializeChannelAsset,
  serializeChannelAsset,
} from "./types/channelState";

// LPConfirmETH tells the backend an ETH deposit/withdraw wallet tx has
// confirmed, so it can notify the hub (the backend never sees the wallet tx).
// txHash is for observability only; hub mirrors GetQuote's hub id.
@jsonObject()
export default class LPConfirmETH extends PerunMessage {
  @jsonMember({
    deserializer: deserializeChannelAsset,
    serializer: serializeChannelAsset,
  })
  asset: ChannelAsset;
  @jsonMember(String) txHash: string;
  @jsonMember(String) hub: string;

  constructor(asset: ChannelAsset, txHash: string, hub: string) {
    super();
    this.asset = asset;
    this.txHash = txHash;
    this.hub = hub;
  }

  messageType(): MessageType {
    return LPConfirmETH;
  }

  messageTypeName(): MessageTypeName {
    return "LPConfirmETH";
  }
}
